

import {
  Component,
  OnInit,
  ViewChild,
} from "@angular/core";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { onSnapshot } from "firebase/firestore";
import { NGXLogger } from "ngx-logger";
import { ConfirmationService, MenuItem, MessageService } from "primeng/api";

import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from "primeng/dynamicdialog";
import { Subject } from "rxjs";
import { MandatoDiPagamento } from "src/app/models/mandatoDiPagamento.model";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";
import { FormattaNumeroPipe } from "src/app/pipes/formatta-numero.pipe";
import { ExcelService } from "src/app/services/excelService.service";

import { StiliService } from "src/app/services/stili.service";
import { UtilService } from "src/app/services/util.service";
import { environment } from "src/environments/environment";


@Component({
  templateUrl: "./dialog-pratiche-oda.component.html",
  styleUrls: ["../bef.component.css"],
})
export class PraticheOdaComponent implements OnInit {
  protected _onDestroy              = new Subject<void>();
  
  protected isLoadingPraticheOda:Boolean = false;
  protected mdp:MandatoDiPagamento;
  protected pratiche:PraticaFlowdy2_Firestore[]=[];
  protected importoTotaleFase1:number       = 0;
  protected importoTotaleFase2:number       = 0;
  protected importoTotaleOpereExtra:number  = 0;
  protected importoTotaleFase3:number       = 0;
  protected importoTotaleKO:number          = 0;


  private collection_pratiche:string = environment.firebase.collection_pratiche;

  @ViewChild("praticheDT", { static: true }) praticheDT: any;
  

  constructor(
    private logger: NGXLogger,
    public dialogRef: DynamicDialogRef,
    public stiliService:StiliService,
    public config: DynamicDialogConfig,
    private messageService: MessageService,
    private utilService:UtilService,
    public firestore: AngularFirestore,
    private excelService: ExcelService,
  ) {
    this.mdp  = this.config.data.mdp;
  }

  ngOnInit(): void {
    this.loadPraticheDelMandatoDiPagamentoFase1();
    this.loadPraticheDelMandatoDiPagamentoFase2();
    this.loadPraticheDelMandatoDiPagamentoFase3();
    this.loadPraticheDelMandatoDiPagamentoKO();
  }

  esportaPratiche(){
    this.excelService.exportPraticheMandatoDiPagamentoToExcel(this.pratiche,this.mdp , 'pratiche_mdp'+this.mdp.id+'.xlsx');
  }

  loadPraticheDelMandatoDiPagamentoFase1(){
    const collectionRef = this.firestore.collection(this.collection_pratiche).ref;
        let queryFase1 = collectionRef
        .where("idMandatoDiPagamentoFase1", "==", this.mdp.id)
        .where("numeroOdaFase1", "==", this.mdp.oda.numero);
        onSnapshot(queryFase1, (qs) => {
          //this.logger.info("[PRATICHE MDP] onSnapshot dei dati di FASE 1 > "+ qs.docs.length);
           qs.forEach((doc) => {
            let pratica = doc.data() as PraticaFlowdy2_Firestore;
            let importoFase1        = pratica.importoDovutoFase1 && pratica.importoDovutoFase1 !==0 ? Number(pratica.importoDovutoFase1) : Number(pratica.importoPagatoFase1);
            this.importoTotaleFase1 = Number((this.importoTotaleFase1 + importoFase1).toFixed(2));
           // this.logger.info("[PRATICHE MDP] onSnapshot dei dati di FASE 1 > "+ pratica.cui + " "+ pratica.importoDovutoFase1);

            if (!this.pratiche.some(p => p.id === pratica.id)) {
              this.pratiche.push(pratica);
             
          /*      if(pratica.idMandatoDiPagamentoFase2 === this.mdp.id){
                this.importoTotaleFase2 += Number(pratica.importoDovutoFase2);
              }
              if(pratica.idMandatoDiPagamentoFase3=== this.mdp.id){
                this.importoTotaleFase3 += Number(pratica.importoDovutoFase3);
              }
              if(pratica.idMandatoDiPagamentoKO=== this.mdp.id){
                this.importoTotaleKO += Number(pratica.importoDovutoFase3);
              }  */
            }
           
          });
        });
  }
  loadPraticheDelMandatoDiPagamentoFase2(){
    const collectionRef = this.firestore.collection(this.collection_pratiche).ref;
        let queryFase2 = collectionRef
        .where("idMandatoDiPagamentoFase2", "==", this.mdp.id)
        .where("numeroOdaFase2", "==", this.mdp.oda.numero);
        onSnapshot(queryFase2, (qs) => {
          //this.logger.info("[PRATICHE MDP] onSnapshot dei dati di FASE 2 >> "+ qs.docs.length);
           qs.forEach((doc) => {
            let pratica = doc.data() as PraticaFlowdy2_Firestore;
            let importoFase2 = pratica.importoDovutoFase2 && pratica.importoDovutoFase2!=0 ? Number(pratica.importoDovutoFase2) : Number(pratica.importoPagatoFase2);
            this.importoTotaleFase2       += Number(importoFase2);
            this.importoTotaleOpereExtra  += Number(pratica.preventivo);
           
            if (!this.pratiche.some(p => p.id === pratica.id)) {

              this.pratiche.push(pratica);
             
              /* if(pratica.preventivo){
                this.importoTotaleFase2 += Number(pratica.preventivo);
              } */
             /*  if(pratica.idMandatoDiPagamentoFase3=== this.mdp.id){
                this.importoTotaleFase3 += Number(pratica.importoDovutoFase3);
              } */
            }else{
             // this.logger.info("[PRATICHE MDP]  > "+ pratica.cui + " "+ pratica.preventivo);
              this.importoTotaleOpereExtra  += Number(pratica.preventivo);

            }
           
          });
        });
  }
  loadPraticheDelMandatoDiPagamentoFase3(){
    const collectionRef = this.firestore.collection(this.collection_pratiche).ref;
        let queryFase3 = collectionRef
        .where("idMandatoDiPagamentoFase3", "==", this.mdp.id)
        .where("numeroOdaFase3", "==", this.mdp.oda.numero);
        onSnapshot(queryFase3, (qs) => {
         // this.logger.info("[PRATICHE MDP] onSnapshot dei dati di FASE 3 > "+ qs.docs.length);
          
           qs.forEach((doc) => {
            let pratica = doc.data() as PraticaFlowdy2_Firestore;
            let importoFase3        = pratica.importoDovutoFase3 && pratica.importoDovutoFase3!=0 ? Number(pratica.importoDovutoFase3) : Number(pratica.importoPagatoFase3);
            this.importoTotaleFase3 = Number((this.importoTotaleFase3 + importoFase3).toFixed(2));

         //   this.logger.info("[PRATICHE MDP] IN FASE 3 > "+ pratica.cui + " "+ pratica.importoDovutoFase3);
            if (!this.pratiche.some(p => p.id === pratica.id)) {
              this.pratiche.push(pratica);
             // this.importoTotaleFase3 += Number(pratica.importoDovutoFase3);
            

            }
           
          });
        });
  }

  loadPraticheDelMandatoDiPagamentoKO(){
    const collectionRef = this.firestore.collection(this.collection_pratiche).ref;
        let queryFase3 = collectionRef.where("idMandatoDiPagamentoKO", "==", this.mdp.id);
        onSnapshot(queryFase3, (qs) => {
        // this.logger.info("[PRATICHE MDP] onSnapshot dei dati di FASE KO > "+ qs.docs.length);
            qs.forEach((doc) => {
            let pratica = doc.data() as PraticaFlowdy2_Firestore;
            let importoKO = pratica.importoDovutoKO && pratica.importoDovutoKO!=0 ? Number(pratica.importoDovutoKO) : Number(pratica.importoPagatoKO);
            this.importoTotaleKO = Number((this.importoTotaleKO + importoKO).toFixed(2));
           if (!this.pratiche.some(p => p.id === pratica.id)) {
              this.pratiche.push(pratica);
             // this.importoTotaleKO += Number(pratica.importoDovutoKO);

            }
           
          });
        });
  }

  checkImportoPraticaFase1(pratica:PraticaFlowdy2_Firestore):string{
    let importoPratica = null;
    const formattaNumeroPipe = new FormattaNumeroPipe();
    if(pratica.idMandatoDiPagamentoFase1 === this.mdp.id){
      importoPratica = pratica.importoDovutoFase1 && pratica.importoDovutoFase1 !==0 ? Number(pratica.importoDovutoFase1) : Number(pratica.importoPagatoFase1);
    }
    return importoPratica;
  }

  checkImportoPraticaFase2(pratica:PraticaFlowdy2_Firestore):string{
    let importoPratica = null;
    const formattaNumeroPipe = new FormattaNumeroPipe();
    if(pratica.idMandatoDiPagamentoFase2 === this.mdp.id){
      importoPratica = pratica.importoDovutoFase2 && pratica.importoDovutoFase2 !==0 ? Number(pratica.importoDovutoFase2) : Number(pratica.importoPagatoFase2);
    }
    return importoPratica;
  }

  checkImportoPraticaOpereExtra(pratica:PraticaFlowdy2_Firestore):string{
    let importoPratica = null;
    const formattaNumeroPipe = new FormattaNumeroPipe();
    if(pratica.idMandatoDiPagamentoFase2 === this.mdp.id){
      importoPratica = pratica.preventivo ;
    }
    return importoPratica;
  }
  checkImportoPraticaFase3(pratica:PraticaFlowdy2_Firestore):string{
    let importoPratica = null;
    const formattaNumeroPipe = new FormattaNumeroPipe();
    if(pratica.idMandatoDiPagamentoFase3 === this.mdp.id){
      importoPratica = pratica.importoDovutoFase3 && pratica.importoDovutoFase3 !==0 ? Number(pratica.importoDovutoFase3) : Number(pratica.importoPagatoFase3);
    }
    return importoPratica;
  }

  checkImportoPraticaKO(pratica:PraticaFlowdy2_Firestore):string{
    let importoPratica = null;
    const formattaNumeroPipe = new FormattaNumeroPipe();

    if(pratica.idMandatoDiPagamentoKO === this.mdp.id){
      importoPratica = pratica.importoDovutoKO && pratica.importoDovutoKO !==0 ? Number(pratica.importoDovutoKO) : Number(pratica.importoPagatoKO);
    }
    return importoPratica;
  }

  

  filtraPratiche(event: any){
    this.praticheDT.filterGlobal(event.target.value, 'contains');
  }
  
  

  conferma(conferma: boolean) {
    if (!conferma) {
      this.dialogRef.close({ success: false });
    } else {
      this.dialogRef.close({ success: true });
    }
  }
}
